export default __webpack_public_path__ + "static/media/bt4dg512logo.b534565f.png";